import { Site } from '@envato/foundation-types'
import find from 'lodash-es/find'
import isEmpty from 'lodash-es/isEmpty'
import pick from 'lodash-es/pick'

import siteConfigTopLevelCategories from '../../config/sites/categories'
import canonicalUrlAttributes from '../constants/canonicalUrlAttributes'
import { ILocationParams } from '../reducers/reactRouterLocation'
import makeSearchLinkFn from './location/makeSearchLink'

const isTagAlsoACategory = (currentSite: Site, tag: string) => {
  const siteRootCategories = siteConfigTopLevelCategories[currentSite]
  return !isEmpty(find(siteRootCategories, { path: tag }))
}

const isTagOnlySearch = (locationParams: ILocationParams) => {
  return locationParams.tags && !locationParams.category
}

export const buildCanonicalPathForSearchPage = (
  currentSite: Site,
  locationParams: ILocationParams,
  makeSearchLink: typeof makeSearchLinkFn
) => {
  const canonical = pick(locationParams, canonicalUrlAttributes)
  if (
    isTagOnlySearch(locationParams) &&
    isTagAlsoACategory(currentSite, locationParams.tags)
  ) {
    canonical.category = locationParams.tags
    delete canonical.tags
  }
  return makeSearchLink(canonical)
}
